import { useEffect } from 'react';
import { apiPost } from '../api/readerApi';
import { THIRD_PARTY_TYPE, toApiLanguage } from './contentApi';

const tracked = new Set();

export const trackRead = ({ site, lang, contentId, locked }) => {
  const key = [contentId, site, lang, locked].join('|');
  if (!contentId || tracked.has(key)) return;
  tracked.add(key);
  apiPost('/events/read', { site, language: lang, contentId, locked });
};

export const useReadTracking = (piece, { site, lang }) => {
  useEffect(() => {
    if (!piece || piece.tipoContenido === THIRD_PARTY_TYPE) return;
    trackRead({ site, lang: piece.idioma || toApiLanguage(lang), contentId: piece.id, locked: Boolean(piece.bloqueada) });
  }, [piece, site, lang]);
};
